import Vue from 'vue'

export default Vue.extend({
  props: {
    step1: {
      type: String,
      required: true,
    },
    step2: {
      type: String,
      required: true,
    },
    step3: {
      type: String,
      required: true,
    },
    activeStep: {
      type: Number,
      default: 1,
    },
  },
})
